<script setup lang="ts">
import RegisterBusinessPageTab from '@/corePagesModule/components/RegisterBusinessPageTab.vue';

const props = defineProps<{ title: string }>();
</script>
<template>
  <div class="edit-business-layout">
    <h1 class="edit-business-layout__title">{{ props.title }}</h1>
    <div class="edit-business-layout__header__tab">
      <RegisterBusinessPageTab />
    </div>
    <slot />
  </div>
</template>
<style lang="scss" scoped>
.edit-business-layout {
  display: grid;
  padding: 16px;
  gap: 8px;
  *:not(.material-icons) {
    font-family: 'Noto Sans JP';
  }
  &__title {
    font-size: 22px;
    font-weight: 700;
    line-height: 31.86px;
    text-align: left;
    color: $textDefault;
  }
}
</style>
